





























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class ListenersSkeleton extends Vue {
  @Prop({default: 3}) numSkeletons!: number;
}
